import React from 'react';
import { Card, List, Typography } from 'antd';
import { UserType } from '../../../types/user';
import { CourseType } from '../../../types/course';
import getActions from '../actions/courseItemActions';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const { Title, Text } = Typography;

function sortCourses(courses: Array<CourseType>) {
    // 1. If both courses have the same enrollment and draft status, compare their `updated_at` dates:
    //    - The course with the more recent `updated_at` date comes first.

    if (!Array.isArray(courses)) {
        return undefined;
    }

    const mutableCourses = [...courses];
    return mutableCourses.sort((a, b) => {
        return (
            new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime()
        );
    });
}

const CourseList = ({
    courses,
    user,
}: {
    courses: Array<CourseType>;
    user: UserType;
}) => {
    const sortedCourses = sortCourses(courses);
    const { t } = useTranslation();

    const courseTitle = (course) => {
        if (course) {
            if (course.is_published) {
                return `${course.title} (${t('published')})`;
            } else {
                return `${course.title} (${t('draft')})`;
            }
        } else {
            return '';
        }
    };

    return (
        <List
            bordered={false}
            data-cy={'course-catalog-list'}
            size={'large'}
            pagination={{ pageSize: 10 }}
            dataSource={sortedCourses}
            renderItem={(course: CourseType) => (
                <Link to={`/app/course-drafts/${course.id}`}>
                    <Card
                        hoverable
                        data-cy={'course-list-item'}
                        style={{ marginTop: '20px' }}
                        title={<Title level={4}>{courseTitle(course)}</Title>}
                        extra={getActions(course, user)}
                    >
                        {course.description}
                    </Card>
                </Link>
            )}
        />
    );
};

export default CourseList;
